<div class="mid-badge {{ badgeClass }}">
  <ng-content></ng-content>
</div>
